import { Deserializer } from 'jsonapi-serializer';
import { genericError } from '../models/GenericError';
import { ListQuery } from '../models/ListQuery';
import { Name } from '../models/Name';
import { PaginationModel } from '../models/Pagination';

import { TimeZone } from "../models/TimeZone";
import { APIConnector } from './api/APIConnector';
import { createPagination } from './utilities/paginationBuilder';
import { processServerError, getConstraintViolation } from './utilities/ServiceError';
import { createPartialURL, getFilterClause } from './utilities/urlBuilder';

const apiConnector = new APIConnector();

export const getTimeZones = async (listParameters?: ListQuery): Promise<{ rows: Name[], pagination: PaginationModel }> => {
    try {
        const filter = getFilterClause(listParameters?.filters, listParameters?.searchTerm);
        const paginationString = createPartialURL(listParameters?.goToPage, listParameters?.pageSize, listParameters?.sortBy, filter);
        const url = `timeZone?${paginationString ? paginationString.slice(1) : paginationString}`;
        const response = await apiConnector.fetchData(url);
        const json = await response.json();
        const newPagination = createPagination(json.meta);

        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({status: response.status, message: getConstraintViolation(json.errors[0].detail), success: false })
            }

            new Deserializer().deserialize(json, (err: any, apiTimeZones: any[]) => {
                if (err) {
                    return reject({status: response.status, message: genericError });
                }

                const timeZones: TimeZone[] = apiTimeZones.map((timeZone): TimeZone => {
                    return { value: timeZone['id'], label: timeZone['zone'] };
                });

                return resolve({ rows: timeZones, pagination: newPagination });
            })
        })
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}
